import { computed } from 'vue'

import { useI18n } from 'vue-i18n'
import IconPhone from '@/assets/svg/phone-icon.svg?component'
import IconNote from '@/assets/svg/note-icon.svg?component'
import IconMeet from '@/assets/svg/meet-icon.svg?component'
import IconFollow from '@/assets/svg/followme-icon.svg?component'
import IconSort from '@/assets/svg/icon_sort.svg?component'
import IconPerson from '@/assets/svg/person-icon.svg?component'
import { useAuthStore } from '@/stores/useAuthStore'



import type { IRoute } from '../interfaces/route.interface'
import { ArrowRightLeft, Sparkles, Voicemail } from 'lucide-vue-next'

export const useSidebarRoutes = () => {
  const { t } = useI18n()
  const authStore = useAuthStore()

  const canListenRecordings = computed(() =>
    (authStore.extension?.rule_extensions ?? []).some(
      (rule: { description?: string | null; value?: string | null }) =>
        rule.description === 'hub_records' &&
        ['yes', 'true', '1'].includes(
          String(rule.value ?? '')
            .trim()
            .toLowerCase(),
        ),
    ),
  )

  const routes = computed<IRoute[]>(() => {
    const baseRoutes: IRoute[] = [
      {
        path: '/',
        icon: IconPhone,
        title: t('common.titles.webphone'),
      },
      {
        path: '/contacts',
        icon: IconPerson,
        title: t('common.titles.contacts'),
      },
      {
        path: '/notes',
        icon: IconNote,
        title: t('common.titles.notes'),
      },
      {
        path: '/meet',
        icon: IconMeet,
        title: t('common.titles.meet'),
      },
      {
        path: '/historical',
        icon: IconSort,
        title: t('common.titles.historical'),
      },
    ]

    if (canListenRecordings.value) {
      baseRoutes.push({
        path: '/nebula-ai',
        icon: Sparkles,
        title: t('common.titles.nebula_ai'),
      })
    }

    baseRoutes.push(
      {
        path: '/follow-me',
        icon: IconFollow,
        title: t('common.titles.follow_me'),
      },
      {
        path: '/voicemail',
        icon: Voicemail,
        title: t('common.titles.voicemail'),
      },
    )

    return baseRoutes
  })

  return {
    routes,
  }
}
